
import I18n from "../../../../commons/I18n/I18n";
import ScreenCard from "../../../../components/screen/ScreenCard";
import { AppIcon } from "../../../../config/Config";
import I18nKeys from "../../../../I18n/I18nKeys";
import { ROUTE_COMPANY_USER_BLACK_LIST_RULES } from "../../../../routing/Routes";
import BlackListRuleListCardCompanyUser from "./BlackListRuleListCardCompanyUser";

const BlackListRuleListCompanyUserScreen = () => (
  <ScreenCard breadcrumbs={[
    {
      name: I18n.tr(I18nKeys.CONFIGURACION_DE_LISTAS_NEGRAS),
      url: ROUTE_COMPANY_USER_BLACK_LIST_RULES,
      icon: AppIcon.BLACK_LIST_RULE,
    },
  ]}>
    <BlackListRuleListCardCompanyUser/>
  </ScreenCard>
);

export default BlackListRuleListCompanyUserScreen;
